import { ReactNode } from 'react';

import { Dropdown } from 'components/Dropdown/Dropdown';
import { searchGetJobsRoutePath } from 'modules/search/routing/helpers/searchGetJobsRoutePath';

import { FindAJobDropdownMenu } from './FindAJobDropdownMenu';

type Props = {
  locale: UserLocale;
  renderTrigger: (data: {
    triggerText: string;
    triggerHref: string;
  }) => ReactNode;
  trackClickedContext: string;
};

const triggerTextByLocale: Record<UserLocale, { text: string; href: string }> =
  {
    en: {
      text: 'Find a Job',
      href: searchGetJobsRoutePath({ lang: 'en' }),
    },
    es: {
      text: 'Encuentra empleo',
      href: searchGetJobsRoutePath({ lang: 'es' }),
    },
    pt: {
      text: 'Buscar Emprego',
      href: searchGetJobsRoutePath({ lang: 'pt' }),
    },
  };

export function FindAJobDropdown({
  locale,
  renderTrigger,
  trackClickedContext,
}: Props) {
  const { text, href } = triggerTextByLocale[locale];

  return (
    <Dropdown
      trigger={renderTrigger({ triggerText: text, triggerHref: href })}
      desktopTriggersOnHover
    >
      <FindAJobDropdownMenu
        locale={locale}
        trackClickedContext={trackClickedContext}
      />
    </Dropdown>
  );
}
